import React, { useState, useEffect } from "react";
import "../styles/update-users.css";

const ConfirmationModal = ({
    open,
    type,
    user,
    onClose,
    onConfirm,
}) => {
    const status = user?.status === "Inactive" ? "INACTIVE" : "ACTIVE";

    if (!open) return null;

    const isDeactivate = type === "deactivate";
    const isActivate = type === "activate";
    const isRemove = type === "remove";

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 confirmation-modal-overlay">
            <div className="bg-white rounded-3xl w-full overflow-hidden confirmation-modal-inner">

                {/* Header */}
                <div className="p-8 border-b flex justify-between">
                    <div>
                        <h2 className="text-2xl font-bold text-[#053A49]">
                        {isDeactivate
                                ? "Deactivate Dashboard User"
                                : isActivate
                                ? "Reactivate Dashboard User"
                                : "Remove Dashboard User"}
                        </h2>

                        <p className="text-gray-400 mt-2">
                            {isDeactivate
                                ? "This will change the status of the user."
                                : isActivate
                                ? "This will reactivate the user and restore access."
                                : "This will permanently remove the user from your records."}
                        </p>
                    </div>

                    <button onClick={onClose}>✕</button>
                </div>

                {/* Body */}
                <div className="p-8">
                    <label className="font-semibold block mb-2">
                        Full Name *
                    </label>

                    <input
                        value={user?.name || ""}
                        readOnly
                        className="w-full border rounded-lg px-4 py-3 bg-[#F7FBFB]"
                    />

                    {/* Status (read-only) */}
                    {(isDeactivate || isActivate) && (
                        <div className="mt-6">
                            <label className="font-semibold block mb-3">Status</label>
                            <div>
                                <span className={`inline-flex items-center px-3 py-2 rounded-lg font-semibold ${status === "ACTIVE" ? "bg-[#EEF5E4] text-green-700" : "bg-[#FFF4F1] text-orange-600"}`}>
                                    {status === "ACTIVE" ? 'ACTIVE' : 'INACTIVE'}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="border-t p-6 flex justify-center gap-4">
                    <button
                        onClick={onClose}
                        className="px-8 py-3 bg-orange-500 text-white rounded-xl"
                    >
                        CANCEL
                    </button>

                    <button
                        onClick={() =>
                            onConfirm({
                                id: user.id,
                                status,
                                action: type,
                            })
                        }
                        className="px-8 py-3 bg-cyan-600 text-white rounded-xl"
                    >
                        {isDeactivate ? "DEACTIVATE" : isActivate ? "REACTIVATE" : "REMOVE"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;